@if (showLabel()) {
  <span class="label">Your rating:</span>
}
<span *ngIf="rating() === ratingLevels.BelowAverage" class="rating rating--belowAverage">Needs Negotiating</span>
<span *ngIf="rating() === ratingLevels.Average" class="rating rating--average">Average</span>
<span *ngIf="rating() === ratingLevels.AboveAverage" class="rating rating--aboveAverage">Satisfactory</span>
